import Vue from 'vue'
import App from './App.vue'
import router from './router'

import './assets/css/fonts.css'
import './assets/css/fonts-awesome.css'
import './assets/css/style.css'
import './assets/css/cart.css'
import './assets/css/reset.min.css'


Vue.config.productionTip = false

export const bus = new Vue();

router.beforeEach((to, from, next) => {
  document.title = to.meta.title
  next()
});

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
